import { render, staticRenderFns } from "./ChannelIntervalsDrawer.vue?vue&type=template&id=48e08c4b&scoped=true"
import script from "./ChannelIntervalsDrawer.vue?vue&type=script&lang=ts"
export * from "./ChannelIntervalsDrawer.vue?vue&type=script&lang=ts"
import style0 from "./ChannelIntervalsDrawer.vue?vue&type=style&index=0&id=48e08c4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e08c4b",
  null
  
)

export default component.exports